"use strict";
import dynamic from "next/dynamic";
import PropTypes from "prop-types";
const Content = dynamic(() => import("../Content/Content"));
const PostHeader = dynamic(() => import("../PostHeader/PostHeader"));
const SubHeader = dynamic(() => import("../SubHeader/SubHeader"));
const PostImage = dynamic(() => import("../PostImage/PostImage"));
const AffiliateButton = dynamic(
  () => import("../AffiliateButton/AffiliateButton")
);

const Listicle = (props) => {
  const {
    header = { props: {} },
    sub_header = { props: {} },
    image = { props: {} },
    content = { props: {} },
    affiliate = { props: {} },
  } = props;
  return (
    <>
      <div style={{minHeight: "320px"}}>
        {header.props.value && <PostHeader {...header.props} />}
        <div>
          {sub_header.props.value && (
            <SubHeader {...sub_header.props} />
          )}
        </div>
        {Object.keys(image.props.image).length > 0 ? (
          <PostImage
            currentSiteID={props.currentSiteID}
            {...image.props.image}
            size={props.imageSize}
            deviceSize={props.deviceSize}
            className="img-default postImg"
            width="700"
            height="350"
            isLazyLoading={true}
          />
        ) : null}
        {content.props.value && <Content {...content.props} />}
        {affiliate.props.buttonText && affiliate.props.linkUrl && (
          <AffiliateButton {...affiliate.props} className="listicleAf"/>
        )}
      </div>
    </>
  );
};

Listicle.propTypes = {
  header: PropTypes.object,
  sub_header: PropTypes.object,
  image: PropTypes.object,
  content: PropTypes.object,
  affiliate: PropTypes.object,
  deviceSize: PropTypes.number,
  Credited: PropTypes.string,
  currentSiteID: PropTypes.number,
};

export default Listicle;
